<template>
  <div
    :class="elementContainerClasses"
    class="wf-relative"
    @mouseover="hover = true"
    @mouseleave="hover = false"
  >
    <div :class="editorClasses" class="wf-h-full">
      <EditorOptions
        parent="column"
        v-show="hover && ! childHover && ! previewMode"
        :options="menuOptions"
        :parentModule="parentModule"
      />
      <div :style="elementStyles" :class="elementClasses" class="wf-relative wf-h-full">
        <VueResizable
          :active="activeSide"
          :ref="`resizable_${id}`"
          @resize:start="resetSize"
          @resize:end="updateSize"
          :maxWidth="maxWidth"
          width="100%"
          height="100%"
          :fitParent="false"
        >
          <draggable
            class="z-40"
            v-model="components"
            group="components"
            handle=".component-handle"
          >
            <component
              @mouseover="childHover = true"
              @mouseleave="childHover = false"
              v-for="component in components"
              :is="component.slug"
              layoutComponent
              :component="component"
              :key="component.id"
              :parentModule="parentModule"
            ></component>
            <div v-if="! components.length && ! previewMode" class="flex flex-wrap flex-row flex-1">
              <div
                @click.prevent="addComponent"
                style="cursor:pointer; display: flex; color: rgba(0,0,0,.25); align-items: center; justify-content: center; flex:1; border: 1px dashed rgba(0,0,0,.25); padding: 1.5rem 0"
              >
                <i class="fas fa-plus"></i>
              </div>
            </div>
          </draggable>
        </VueResizable>
      </div>
    </div>
  </div>
</template>

<script>
  import Widths from '../mixins/Widths'
  import VueResizable from 'vue-resizable'
  import { ConstantsParser } from '../ConstantsParser'
  import EditorElement from '../contracts/EditorElement'
  import ArrayManipulation from '../mixins/ArrayManipulation'
  import { ColumnsWidthClasses } from '../ColumnsWidthClasses'
  export default EditorElement.extend({
    props: {
      parentModule: {
        type: String,
        required: true
      }
    },
    components: {VueResizable},
    mixins: [ArrayManipulation, Widths],
    watch: {
      siblings(value, oldValue) {
        if (value.length >= oldValue.length) {
          return
        }
        let widthClasses = (new ColumnsWidthClasses).widthForColumns(value.length)
        this.addToArray(this.module, widthClasses[this.device], 'containerClasses', this.device, {}, true, this.parentModule)
      }
    },
    mounted() {
      this.$refs[`resizable_${this.id}`].w = '100%'
      this.$refs[`resizable_${this.id}`].h = '100%'
    },
    computed: {
      menuOptions() {
        return this.properties.menu
      },
      elementContainerClasses() {
        if (this.previewMode) {
          return (new ConstantsParser(this.containerClasses, this.device)).parse()
        }
        let displayClasses = []
        let containerClasses = Object.keys(this.containerClasses).reduce((carry, device) => {
          let deviceDisplayClass = this.containerClasses[device].find(deviceClass => deviceClass.property == 'Display')
          if (deviceDisplayClass) {
            let opacity = 'wf-opacity-100'
            let prefix = ''
            if (device === 'tablet') {
              prefix = 'sm:'
            }
            if (device === 'desktop') {
              prefix = 'lg:'
            }
            if (deviceDisplayClass.value == 'NONE') {
              opacity = 'wf-opacity-50'
            }
            displayClasses.push(`${prefix}${opacity}`)
          }
          let deviceObject = {}
          let deviceClasses = this.containerClasses[device].filter(deviceClass => deviceClass.property != 'Display')
          this.$set(deviceObject, device, deviceClasses)
          return {...carry, ...deviceObject}
        }, {})
        return [...(new ConstantsParser(containerClasses, this.device)).parse(), ...displayClasses]
      },
      activeSide() {
        return this.siblings.length - 1 != this.columnIndex ? ['r'] : []
      },
      module() {
        return 'layoutColumnModule'
      },
      parent() {
        return this.$parent.$parent
      },
      family() {
        return 'columns'
      },
      sectionIndex() {
        return this.parent.sectionIndex
      },
      rowIndex() {
        return this.parent.rowIndex
      },
      columnIndex() {
        let element = {section: 0, row: this.rowIndex}
        return this.$store.getters[`${this.module}/index`](element, this.id, this.parentModule)
      },
      styles() {
        return this.$store.getters[`${this.module}/styles`](this.element, 'styles', this.parentModule)
      },
      classes() {
        return this.$store.getters[`${this.module}/classes`](this.element, 'classes', this.parentModule)
      },
      properties() {
        return this.$store.getters[`${this.module}/properties`](this.element, this.parentModule)
      },
      containerClasses() {
        return this.$store.getters[`${this.module}/classes`](this.element, 'containerClasses', this.parentModule)
      },
      customClasses() {
        return this.$store.getters[`${this.module}/classes`](this.element, 'customClasses', this.parentModule)
      },
      maxPossibleSize() {
        let currentSize = this.containerClasses[this.device].find(containerClass => containerClass.property == 'ColumnWidth')
        currentSize = this.widths[currentSize.value].value
        let nextColumnClasses = this.siblings[this.columnIndex +1].containerClasses[this.device]
        let nextColumnSize = nextColumnClasses.find(containerClass => containerClass.property == 'ColumnWidth')
        nextColumnSize = this.widths[nextColumnSize.value].value
        return nextColumnSize - 1 + currentSize
      },
      maxWidth() {
        return window.innerWidth
      },
      isResizable() {
        return this.siblings.length > 1 && this.columnIndex < this.siblings.length - 1
      }, 
      siblings() {

        return this.$store.getters['layoutRowModule/elements']({section: 0,...this.element}, this.parentModule).columns
      },
      components: {
        get() {
          return this.$store.getters['layoutComponentModule/elements'](this.element, this.parentModule)    
        },
        set(value) {
          this.$store.dispatch('layoutComponentModule/updateOrder', {
            section: this.sectionIndex,
            row: this.rowIndex,
            column: this.columnIndex,
            value,
            parentModule: this.parentModule
          })
        }
      },
    },
    methods: {
      resetSize(event) {
        if (event.width == '100%') {
          let resizeElementWidth = this.$refs[`resizable_${this.id}`].$el.offsetWidth
          this.$refs[`resizable_${this.id}`].w = resizeElementWidth
        }
      },
      updateSize(event) {
        let width = event.width / window.innerWidth
        if (width > .916) {
          width = .916
        }
        if (! this.isResizable) {
          return this.$refs[`resizable_${this.id}`].w = '100%'
        }
        let newSize = this.getWidthClasses(width)
        let classes = Object.keys(this.widths).find(width => this.widths[width].value == newSize)
        classes = this.widths[classes].classes
        if (newSize > this.maxPossibleSize) {
          classes = this.widths['WIDTH_12_12'].classes
        }
        this.updateNextSiblingSize(classes)
        this.updateColumnSize(classes)
      },
      updateNextSiblingSize(classes) {
        let originalSize = this.siblings[this.columnIndex]
           .containerClasses[this.device]
           .find(contClass => contClass.property == 'ColumnWidth').value
        originalSize = this.widths[originalSize].value
        let newSize = classes[this.device].find(colClass => colClass.property == 'ColumnWidth').value
        newSize = this.widths[newSize].value
        if (newSize == 'WIDTH_12_12') {
          newSize = 11
        }
        let changeToNextColumn = newSize - originalSize
        let nextColumnIndex = this.columnIndex + 1
        let nextColumn = this.siblings[nextColumnIndex]
        let nextColumnSize = nextColumn.containerClasses[this.device].find(contClass => contClass.property == 'ColumnWidth').value
        nextColumnSize = this.widths[nextColumnSize].value - changeToNextColumn
        if (nextColumnSize < 1) {
          nextColumnSize = 1
        }
        let newWidth = Object.keys(this.widths).find(width => this.widths[width].value == nextColumnSize)
        newWidth = this.widths[newWidth].classes[this.device]
        this.addToArray(this.module, newWidth, 'containerClasses', this.device, {column: nextColumnIndex}, true, this.parentModule)
      },
      updateColumnSize(classes) {
        this.addToArray(this.module, classes[this.device], 'containerClasses', this.device, {}, true, this.parentModule)
        this.$refs[`resizable_${this.id}`].w = '100%'
      },
      addComponent() {
        this.$modal.show('newComponentModal', {
          ...this.element,
          section: 0,
          layoutSectionComponent: true,
          parentModule: this.parentModule
        })
      }
    }
  })
</script>